/** Vendors */
import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";

/** Custom Reducers */
import rootReducer from "./reducers/index";

/** Custom APIs */
import business from "../api/business";
import customer from "../api/customer";
import file from "../api/file";
import member from "../api/member";
import notification from "../api/notification";
import project from "../api/project";
import review from "../api/review";
import vendor from "../api/vendor";

/** Types */
import type { ThunkAction } from "redux-thunk";

import type {
  AnyAction,
  DevToolsEnhancerOptions,
  Middleware,
} from "@reduxjs/toolkit";

declare module "redux" {
  interface Dispatch<A extends Action = AnyAction> {
    <S, E, R>(asyncAction: ThunkAction<R, S, E, A>): R;
  }
}

const middleware: Middleware[] = [thunk];

const devToolsEnhancer: DevToolsEnhancerOptions = {
  trace: true,
  traceLimit: 25,
};

const extraArgument = {
  business,
  customer,
  file,
  member,
  notification,
  project,
  review,
  vendor,
};

const env = import.meta.env.META;

const store = configureStore({
  devTools: env !== "development" ? devToolsEnhancer : false,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      thunk: {
        extraArgument,
      },
    }).concat(middleware);
  },
  reducer: rootReducer,
});

// Infer the `IRootState` and `IAppDispatch` types from the store itself
export type IAppApi = typeof extraArgument;

export type IGetState = typeof store.getState;

export type IRootState = ReturnType<IGetState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type IAppDispatch = typeof store.dispatch;

export type { AnyAction };

export default store;
